export const mockPosts = {
	'AnA2-P15c': {
		name: 'New page',
		path: '/howtomakenachos',
		blocks: [
			'AnA2-P15c-header',
			'AnA2-P15c-section',
		],
		type: 'blog',
		customData: {
			hidden: false,
			coverImage: {
				src: 'https://images.unsplash.com/photo-1582169296194-e4d644c48063?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080&fit=max&ixid=eyJhcHBfaWQiOjcyNTgzfQ',
				alt: 'selective focus photography of white USB port',
			},
			date: '2020-06-01',
			categories: [],
			minutesToRead: '4',
		},
		meta: {
			title: 'How to make the perfect nachos',
			description: 'Nachos are tasty. But they can be made even better.',
		},
	},
	xYeRqh3F4: {
		name: 'New page',
		path: '/pullingallnighters',
		blocks: [
			'xYeRqh3F4-header',
			'xYeRqh3F4-section',
		],
		type: 'blog',
		customData: {
			hidden: false,
			coverImage: {
				src: 'https://images.unsplash.com/photo-1536746803623-cef87080bfc8?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080&fit=max&ixid=eyJhcHBfaWQiOjcyNTgzfQ',
				alt: 'four brown gift boxes on white surface',
			},
			date: '2020-06-01',
			categories: [],
			minutesToRead: '1',
		},
		meta: {
			title: 'Pulling all nighters',
			description: 'Every developer has done this. And will do it again and again and again...',
		},
	},
};
